import FeatureSectionTwo, { FeatureSectionTwoProps } from './FeatureSectionTwo'

export default FeatureSectionTwo

export { FeatureSectionTwo }
export type { FeatureSectionTwoProps }
